export function getBanlists ({ state, commit }, { search, page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banlists', { params: { search, page } })
      .then((response) => {
        if (response.data.banlists) {
          commit('setBanlists', response.data.banlists)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getBanlist ({ state, commit }, banlistId) {
  return new Promise((resolve, reject) => {
    if (banlistId) {
      axiosInstance.get('/v1/banlists/' + banlistId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlist id'))
    }
  })
}

export function getCreateBanlist ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banlists/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createBanlist ({ state, commit }, { ip, clientKEY, motiv }) {
  return new Promise((resolve, reject) => {
    const params = ip.length > 0 ? { ip, motiv } : { clientKEY, motiv }
    axiosInstance.post('/v1/banlists', params)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditBanlist ({ state, commit }, banlistId) {
  return new Promise((resolve, reject) => {
    if (banlistId) {
      axiosInstance.get('/v1/banlists/' + banlistId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlist id'))
    }
  })
}

/* eslint-disable-next-line */
export function editBanlist ({ state, commit }, { id, description, procent }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/banlists/' + id, { description, procent })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlist id'))
    }
  })
}

export function deleteBanlist ({ state, commit }, banlistId) {
  return new Promise((resolve, reject) => {
    if (banlistId) {
      axiosInstance.delete('/v1/banlists/' + banlistId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlist id'))
    }
  })
}

export function switchBan ({ state, commit }, banlistId) {
  return new Promise((resolve, reject) => {
    if (banlistId) {
      axiosInstance.patch('/v1/banlists/' + banlistId + '/switch')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlist id'))
    }
  })
}
